/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import AppContext from "AppContext";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

import logo from 'assets/img/brand/logo-viatech.png'
import { validateEmail } from "services/Utils";
import Error from "components/Error";
import { alert } from "components/Alert";
import { erroInesperado } from "services/Utils";
import AlterarSenha from "./AlterarSenha";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import authService from "services/AuthService";
import Alert from "components/Alert";
import { toast } from "react-toastify";

const ResetarSenha = () => {
  let [searchParams] = useSearchParams()
  const [data, setData] = useState({
    token: searchParams.get('token'),
    novaSenha: '',
    confirmacaoSenha: ''
  })
  const [errors, setErrors] = useState([])
  const [configAlterarSenha, setConfigAlterarSenha] = useState()
  const { state, actions } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (state.user) {
      navigate('/admin')
    }
  }, [state])

  const validar = () => {
    const errors = []
    if (!data?.novaSenha) {
      errors.push({
        fieldName: 'novaSenha',
        error: 'Campo obrigatório'
      })
    }
    if (!data?.confirmacaoSenha) {
      errors.push({
        fieldName: 'confirmacaoSenha',
        error: 'Campo obrigatório'
      })
    }
    if (data.novaSenha !== data.confirmacaoSenha) {
      errors.push({
        fieldName: 'confirmacaoSenha',
        error: 'As senhas não conferem'
      })
    } setErrors(errors)
    return errors.length === 0
  }

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = async (ev) => {
    ev.preventDefault()

    if (validar()) {
      try {
        showLoading()

        const res = await authService.resetarSenha(data.token, data.novaSenha)
        if (res.success) {
          alert({
            header: 'Alteração de senha',
            text: 'Senha alterada com sucesso, estamos te redirecionando para a tela de login',
            onClose: () => {
              navigate('/auth/login', {
                replace: true
              })
            }
          })
        } else {
          console.log(res)
        }

        hideLoading()
      } catch (ex) {
        console.log(ex)
        hideLoading()
        if (ex.status == 400 && ex?.response?.data?.message) {
          toast(ex?.response?.data?.message)
          return
        }
        erroInesperado()
      }
    }
  }

  return (
    <>
      <AlterarSenha config={configAlterarSenha} onClose={() => setConfigAlterarSenha()} />
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="mb-4 text-center">
              <img src={logo} style={{ width: 200 }} alt="VIATECH" />
            </div>
            <div className="text-center text-muted mb-4">
              <small>Crie uma nova senha</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Nova Senha"
                    type="password"
                    autoComplete="new-password"
                    value={data.novaSenha}
                    onChange={e => handleChange('novaSenha', e.target.value)}
                  />
                </InputGroup>
                <Error errors={errors} fieldName="novaSenha" className="mt-1" />
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Confirme a Nova Senha"
                    type="password"
                    autoComplete="new-password-confirm"
                    value={data.confirmacaoSenha}
                    onChange={e => handleChange('confirmacaoSenha', e.target.value)}
                  />
                </InputGroup>
                <Error errors={errors} fieldName="confirmacaoSenha" className="mt-1" />
              </FormGroup>
              <Row className="align-items-center">
                <Col>

                </Col>
                <Col className="text-right">
                  <Button className="my-2" color="primary" type="submit">
                    Alterar senha
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ResetarSenha;
